import React from 'react';
import style from './NutritionAnalysisCard.module.css';

/**
 * 영양 분석 카드
 *
 * @param {{
 *   kcal: number, sodium: number, protein: number,
 *   carb: number, fat: number
 * }} nutrition
 */
const NutritionAnalysisCard = ({ calorRec, loading = false, pending = false }) => {
    const items = [
        { label: '칼로리',   value: Math.round(Number(calorRec.energy ?? 0)),    unit: 'Kcal' },                   // 정수 표기 (소수점 첫째 자리에서 반올림)
        { label: '나트륨',   value: Math.round(Number(calorRec.sodium ?? 0)),  unit: 'mg' },                       // 정수 표기 (소수점 첫째 자리에서 반올림)
        { label: '단백질', value: Math.round(Number(calorRec.protein ?? 0) * 10) / 10, unit: 'g' },                // 소수점 첫째 자리까지 표기 (소수점 둘째 자리에서 반올림)
        { label: '탄수화물', value: Math.round(Number(calorRec.carbohydrate ?? 0) * 10) / 10, unit: 'g' },         // 소수점 첫째 자리까지 표기 (소수점 둘째 자리에서 반올림)
        { label: '지방', value: Math.round(Number(calorRec.fat ?? 0) * 10) / 10, unit: 'g' },                     // 소수점 첫째 자리까지 표기 (소수점 둘째 자리에서 반올림)
    ];
    if (pending && !loading) {
        return <div className={style.card} data-placeholder="true" />;
    }

    if (loading) {
        return (
            <div className={style.card}>
                <ul className={style.grid}>
                    {items.map((it) => (
                        <li key={it.label}>
                            <span className={style.skeletonLabel} />
                            <span className={style.skeletonValue} />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    return (
        <div className={style.card}>
            <h3 className={style.title}>영양 분석</h3>
            <ul className={style.grid}>
                {items.map((it) => (
                    <li key={it.label}>
                        <span className={style.label}>{it.label}</span>
                        <span className={style.value}>
                            {/* {it.value.toLocaleString()} */}
                            {Number(it.value ?? 0).toLocaleString('ko-KR')}
                            <em>{it.unit}</em>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NutritionAnalysisCard;